import styled from 'styled-components'

export const PrivacyPolicyLinkContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  text-align: left;

  > section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
`
